// src/stone/illustrations/StonjiArrowUpIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiArrowUpIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h64v64H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M47.998 39.999a16.002 16.002 0 0 1-32 0h4a12.002 12.002 0 0 0 24 0"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M47.998 9.965h-4V40h4z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M47.435 11.388 44.606 8.56l-8.024 8.024 2.828 2.828z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M52.643 19.428 55.47 16.6l-8.024-8.025-2.828 2.829z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M46 11.999a2.001 2.001 0 1 0 0-4.003 2.001 2.001 0 0 0 0 4.003M54 20.001a2.002 2.002 0 1 0 0-4.003A2.002 2.002 0 0 0 54 20M37.998 20.001a2.002 2.002 0 1 0 0-4.003 2.002 2.002 0 0 0 0 4.003M18 40a2.002 2.002 0 1 0 0-4.004 2.002 2.002 0 0 0 0 4.003"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M19.998 37.998h-4v2.001h4z" })
    ]
  }
);
var StonjiArrowUpIllustration_default = StonjiArrowUpIllustration;

export {
  StonjiArrowUpIllustration_default
};
